import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../shared/services/common.service';
import { ApiService } from '../../../../../shared/services/api.service';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subscription, switchMap } from 'rxjs';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { IAReverseBuyerRequirementTableModel } from '../../../../../shared/models/IA-ReverseBuyerSeller';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ConfirmationDialogComponent } from '../../../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import saveAs from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-reversebuyerrequirement',
  templateUrl: './reversebuyerrequirement.component.html',
  styleUrl: './reversebuyerrequirement.component.css',
  providers: [DatePipe],
})
export class ReversebuyerrequirementComponent {


  dataSource!: MatTableDataSource<IAReverseBuyerRequirementTableModel>
  displayedColumns: string[] = ['Sr.No', 'reverseBuyerRequirementID', 'buyerRequirementName', 'budget', 'hsnCode', 'category', 'product', 'location', 'Actions']

  // displayedColumns: string[] = ['Sr.No', 'reverseBuyerRequirementID', 'buyerRequirementName', 'budget', 'hsnCode', 'category', 'product', 'location', 'timeLineFromDate', 'timeLineToDate', 'termAndConditions','Actions']


  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';
  reportData: any[] = [];
  allrecord: any[] = [];
  private dataSubscription: Subscription = new Subscription();
  data: any[];

  buyerrequirementdetails: any[] = []

  formData: any
  buttonText: string = 'Save';
  //focusSectorId: any;
  Formloaded: boolean = false;
  usertype: any;// this is for condition of if usertype=mssidc ngoninit()

  pageSizeOptions: number[] = [10, 20, 50, 100];
  page = 1;
  pageSize = 10;
  length: number = 0;
  DtoPagination =
    {
      "PageNumber": 1,
      "PageSize": 10,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }


  constructor(
    public dialog: MatDialog,
    private router: Router, private toastr: ToastrService,
    private common: CommonService,
    private fb: FormBuilder,
    private apiService: ApiService,
    private datePipe: DatePipe


  ) {
    this.data = [];
    this.dataSubscription;
  }

  BuyerForm = new FormGroup({
    buyerRequirementName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(200), Validators.pattern(this.common.nameWithHypen)]),
    budget: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(200)]),
    category: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(200)]),
    hsnCode: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(200)]),
    product: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(200), Validators.pattern(this.common.nameWithHypen)]),
    location: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(200), Validators.pattern(this.common.nameWithHypen)]),
    timelineFromDate: new FormControl<Date | null>(null, [Validators.required]),
    timelineToDate: new FormControl<Date | null>(null, [Validators.required]),

    //timelineFromDate: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]),
    //timelineToDate: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]),
    termAndConditions: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]),
    reverseBuyerRequirementID: new FormControl(''),
    searchControl: new FormControl('', [
      Validators.pattern(this.common.searchFilter)
    ])

  })

  //ngOnInit(): void {
  //  this.usertype = sessionStorage.getItem('UserType');
  //  this.DtoPagination.PageSize = 20;
  //  if (!this.Formloaded) {
  //    this.getData(this.DtoPagination);
  //    this.Formloaded = true;
  //  }


  //}
  ngOnInit(): void {

    this.DtoPagination.PageSize = 10;
    this.DtoPagination.SearchCol = this.common.searchText;
  }

  ngAfterViewInit() {
    this.getData();
  }

  getData() {
    this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
    merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
      this.pagination.page)
      .pipe(filter(searchTerm => searchTerm != null),
        switchMap((searchTerm) => {
          if (searchTerm) {
            this.pagination.pageIndex = 0;
          }
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.common.searchText;
          return this.apiService.getRequest(API_ENDPOINTS.REVERSEBUYERSELLER.GETBUYERREQUIREMENT, this.DtoPagination)
            .pipe(catchError(() => of(null)));

        }),
        map(resp => {
          if (resp.status) {
            this.length = resp['totalRecords'];
            //console.log(resp)
            //console.log("Available Data:", this.dataSource.data);
            //console.log("Searching for ID:", reverseBuyerRequirementID);

            //this.selectedState = resp.data; // Ensure this is correctly assigned
            //console.log("focus sector details:", this.selectedState)

          }
          return resp.data;

        })
      ).subscribe(data => {
        this.dataSource = new MatTableDataSource(data);
        //console.log("datasource", this.dataSource)

        //this.dataSource = data;
        this.adjustPaginator();

        // Reintroduce the logic to change button text to 'Submit'
        this.BuyerForm.get('buyerRequirementName')?.enable();
        this.BuyerForm.get('budget')?.enable();
        this.BuyerForm.get('category')?.enable();
        this.BuyerForm.get('hsnCode')?.enable();
        this.BuyerForm.get('product')?.enable();
        this.BuyerForm.get('location')?.enable();
        this.changeButtonText('Submit'); // Button Change to Submit


      });
  }
  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  //getData(DtoPagination: any) {
  //  // API call to get focus sector details
  //  this.apiService.getRequest(API_ENDPOINTS.REVERSEBUYERSELLER.GETBUYERREQUIREMENT, this.DtoPagination).subscribe(
  //    (response: any) => {
  //      if (response.status) {
  //        this.data = response.data;
  //        this.length = response['totalRecords']
  //        this.buyerrequirementdetails = Array.isArray(response.data) ? response.data : [];
  //        //console.log("buyer seller", this.buyerrequirementdetails)
  //        setTimeout(() => {
  //          this.changeButtonText('Submit');
  //        }, 1000);
  //      } else {
  //        console.error('Error fetching focus sector data');
  //      }
  //    },
  //    (error: any) => {
  //      console.error('Error fetching focus sector data:', error);
  //    }
  //  );
  //}



  changeButtonText(newText: string): void {
    this.buttonText = newText;
  }

  onCancel(): void {
    //this.form1.reset();
    //sessionStorage.removeItem('UpdateID'); // Clear the update ID
    //this.changeButtonText('Save'); // Reset the button text
    window.location.reload();
  }
  onEdit(reverseBuyerRequirementID: any): void {

    const selectedReverseBuyer = this.dataSource.data.find(x => x.reverseBuyerRequirementID === reverseBuyerRequirementID);
    //const selectedReverseBuyer = this.buyerrequirementdetails.find(x => x.reverseBuyerRequirementID === reverseBuyerRequirementID);
    sessionStorage.setItem('UpdateID', reverseBuyerRequirementID);
    
    if (selectedReverseBuyer) {
      this.BuyerForm.patchValue({
        buyerRequirementName: selectedReverseBuyer.buyerRequirementName,
        budget: selectedReverseBuyer.budget ? selectedReverseBuyer.budget.toString() : '',  // Convert number to string
        category: selectedReverseBuyer.category,
        hsnCode: selectedReverseBuyer.hsnCode ? selectedReverseBuyer.hsnCode.toString() : '',  // Convert number to string
        product: selectedReverseBuyer.product,
        location: selectedReverseBuyer.location,
        timelineFromDate: selectedReverseBuyer.timeLineFromDate ? new Date(selectedReverseBuyer.timeLineFromDate) : null,
        timelineToDate: selectedReverseBuyer.timeLineToDate ? new Date(selectedReverseBuyer.timeLineToDate) : null,
        termAndConditions: selectedReverseBuyer.termAndConditions,
      });

      this.BuyerForm.get('buyerRequirementName')?.enable();
      this.BuyerForm.get('budget')?.enable();
      this.BuyerForm.get('category')?.enable();
      this.BuyerForm.get('budget')?.enable();
      this.BuyerForm.get('hsnCode')?.enable();
      this.BuyerForm.get('product')?.enable();
      this.BuyerForm.get('location')?.enable();
      this.BuyerForm.get('timelineFromDate')?.enable();
      this.BuyerForm.get('timelineToDate')?.enable();
      this.BuyerForm.get('termAndConditions')?.enable(); // Ensure the form is editable
      this.changeButtonText('Update'); // Update the button text to "Update"
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  //formatDate(date: string | null): string | null {
  //  if (!date) return null;
  //  const d = new Date(date);
  //  if (isNaN(d.getTime())) return null; // Invalid date
  //  return d.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
  //}
  formatDate(date: string | null): string | null {
    if (!date) return null;

    const d = new Date(date);
    if (isNaN(d.getTime())) return null; // Invalid date

    // Use toLocaleDateString() to format the date in dd/mm/yyyy format
    const formattedDate = d.toLocaleDateString('en-GB'); // 'en-GB' gives dd/mm/yyyy format

    // Convert the date to yyyy-mm-dd format for the input field
    const [day, month, year] = formattedDate.split('/');
    const inputDate = `${year}-${month}-${day}`;

    //console.log("Input Date for Input Field: ", inputDate); // Debugging

    return inputDate;
  }


  onDelete(reverseBuyerRequirementID: any): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: { message: 'Are you sure you want to delete this Buyer Requirement details?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { // If user confirms deletion
        const selectedReverseBuyer = this.dataSource.data.find(x => x.reverseBuyerRequirementID === reverseBuyerRequirementID);
        sessionStorage.setItem('DeleteID', reverseBuyerRequirementID);

        //sessionStorage.setItem('DeleteID', reverseBuyerRequirementID);

        if (selectedReverseBuyer) {
          // Populate the form with selected buyer requirement data
          this.BuyerForm.patchValue({
            buyerRequirementName: selectedReverseBuyer.buyerRequirementName,
            budget: selectedReverseBuyer.budget ? selectedReverseBuyer.budget.toString() : '',  // Convert number to string
            category: selectedReverseBuyer.category,
            hsnCode: selectedReverseBuyer.hsnCode ? selectedReverseBuyer.hsnCode.toString() : '',  // Convert number to string
            product: selectedReverseBuyer.product,
            location: selectedReverseBuyer.location,
            timelineFromDate: selectedReverseBuyer.timeLineFromDate ? new Date(selectedReverseBuyer.timeLineFromDate) : null,
            timelineToDate: selectedReverseBuyer.timeLineToDate ? new Date(selectedReverseBuyer.timeLineToDate) : null,
            termAndConditions: selectedReverseBuyer.termAndConditions
          });

          // Disable form fields as it's marked for deletion
          this.BuyerForm.get('buyerRequirementName')?.disable();
          this.BuyerForm.get('budget')?.disable();
          this.BuyerForm.get('category')?.disable();
          this.BuyerForm.get('hsnCode')?.disable();
          this.BuyerForm.get('product')?.disable();
          this.BuyerForm.get('location')?.disable();
          this.BuyerForm.get('timelineFromDate')?.disable();
          this.BuyerForm.get('timelineToDate')?.disable();
          this.BuyerForm.get('termAndConditions')?.disable();

          this.changeButtonText('Delete'); // Update the button text to "Delete"
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    });
  }

  //prepareFormData(): FormData {
  //  const formData = new FormData();

  //  Object.keys(this.BuyerForm.value).forEach(key => {
  //    let value = this.BuyerForm.get(key)?.value;

  //    //// Format dateOfIncorporation before appending
  //    //if (key === 'dateOfIncorporation' && value) {
  //    //  value = this.datePipe.transform(value, 'dd/MM/yyyy'); // Format date
  //    //}

  //    // Format dateOfIncorporation before appending
  //    if (key === 'timelineFromDate' && value) {
  //      value = this.datePipe.transform(value, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
  //    }
  //    if (key === 'timelineToDate' && value) {
  //      value = this.datePipe.transform(value, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
  //    }


  //    if (value !== null) {
  //      formData.append(key, value);
  //    }
  //  });

   
  //  return formData;
  //}



  onSubmit() {
    if (this.BuyerForm.invalid) {
      this.toastr.error('please fill out all required fields.');
      return;
    }

    //const formData = this.prepareFormData();
    // Extract form values
    //const formData = this.BuyerForm.value;
    //formData.isActive = true; 
    //console.log("formData", formData)

    //below button Submit 
    if (this.buttonText == "Submit") {
      this.formData = {
        buyerRequirementName: this.BuyerForm.controls.buyerRequirementName.value,
        budget: this.BuyerForm.controls.budget.value?.toString(), // Ensure it's a string if needed
        category: this.BuyerForm.controls.category.value,
        hsnCode: this.BuyerForm.controls.hsnCode.value,
        product: this.BuyerForm.controls.product.value,
        location: this.BuyerForm.controls.location.value,
        timelineFromDate: this.datePipe.transform(this.BuyerForm.controls.timelineFromDate.value, 'yyyy-MM-dd'),
        timelineToDate: this.datePipe.transform(this.BuyerForm.controls.timelineToDate.value, 'yyyy-MM-dd'),

        //timelineFromDate: this.BuyerForm.controls.timelineFromDate.value,
        //timelineToDate: this.BuyerForm.controls.timelineToDate.value,
        termAndConditions: this.BuyerForm.controls.termAndConditions.value,
        isActive: true
        //createdBy:1
        //createdBy: this.userMasterUserId,
      };
      //console.log("before api formdata", this.formData)
      this.apiService.postRequest(API_ENDPOINTS.REVERSEBUYERSELLER.SAVEBUYERREQUIREMENT,this.formData).subscribe(
        response => {

          this.toastr.success(response.message);
          this.BuyerForm.reset(); 
          window.location.reload();
        },
        error => {
          this.handleError(error, 'already exists');
        }
      );
    }
    // Handle 'Update' operation
    else if (this.buttonText === 'Update') {
      const updateId = sessionStorage.getItem('UpdateID');
      

      if (!updateId) {
        this.toastr.error('No UpdateID found in session storage.');
        return;
      }

      this.formData = {

        //buyerRequirementName: this.BuyerForm.controls.buyerRequirementName.value,
        reverseBuyerRequirementID: sessionStorage.getItem('UpdateID'),
        buyerRequirementName: this.BuyerForm.controls.buyerRequirementName.value,
        budget: this.BuyerForm.controls.budget.value,
        category: this.BuyerForm.controls.category.value,
        hsnCode: this.BuyerForm.controls.hsnCode.value,
        product: this.BuyerForm.controls.product.value,
        location: this.BuyerForm.controls.location.value,
        timelineFromDate: this.datePipe.transform(this.BuyerForm.controls.timelineFromDate.value, 'yyyy-MM-dd'),
        timelineToDate: this.datePipe.transform(this.BuyerForm.controls.timelineToDate.value, 'yyyy-MM-dd'),

        //timelineFromDate: this.BuyerForm.controls.timelineFromDate.value,
        //timelineToDate: this.BuyerForm.controls.timelineToDate.value,
        termAndConditions: this.BuyerForm.controls.termAndConditions.value,
        isActive: true

      };
      
      this.apiService.postRequest(API_ENDPOINTS.REVERSEBUYERSELLER.UPDATEBUYERREQUIREMENT, this.formData).subscribe(
        response => {
          this.toastr.success(response.message);
          this.BuyerForm.reset(); 
          window.location.reload();
        },
        error => {
          this.handleError(error, 'already exists');
        }
      );
    }
    // Handle 'Delete' operation
    else if (this.buttonText === 'Delete') {
      const deleteId = sessionStorage.getItem('DeleteID');

      if (!deleteId) {
        this.toastr.error('No DeleteID found in session storage.');
        return;
      }

      this.formData = {
        reverseBuyerRequirementID: deleteId
      };

      this.apiService.postRequest(API_ENDPOINTS.REVERSEBUYERSELLER.DELETEBUYERREQUIREMENT, this.formData).subscribe(
        response => {
          this.toastr.success(response.message);
          this.BuyerForm.reset(); 
          window.location.reload();
        },
        error => {
          this.handleError(error, 'An error occurred during deletion.');
        }
      );
    }
  }


  // Handle API errors
  handleError(error: any, defaultErrorMessage: string) {
    let errorMessage = defaultErrorMessage;
    if (error.status === 409) {
      errorMessage = 'Conflict: Item already exists.';
    } else if (error.status === 400) {
      errorMessage = 'Bad Request';
    }
    this.toastr.error(errorMessage);
  }

  removeExtraSpaces(controlName: string): void {
    const control = this.BuyerForm.get(controlName);
    if (control && control.value) {
      // Trim leading and trailing spaces and replace multiple spaces with a single space
      const sanitizedValue = control.value.trim().replace(/\s+/g, ' ');
      control.setValue(sanitizedValue);
    }
  }




  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  onPageChange(e: PageEvent) {

    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.getData();
  }

    onSearchClick(searchValue: string): void {
      const searchControl = this.BuyerForm.get('searchControl');
      searchControl?.markAsTouched(); // Mark the control as touched for validation feedback

      if (searchControl?.valid && searchValue.trim() !== '') {
        this.DtoPagination.SearchTerm = searchValue.trim();
        this.getData(); // Fetch filtered data
        //console.log('Search triggered with value:', searchValue);
      } else if (searchValue.trim() === '') {
        console.error('Search term is empty');
      } else {
        console.error('Invalid search term');
      }
  }

  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.common.searchText;
    this.getData();
  }

  exportToExcel(): void {
    const fileName = 'Buyer_Requirement_Form_List.xlsx';

    const DtoPagination = {
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "buyerRequirementName",
      SortDirection: "desc",
      SearchTerm: "",
      SearchCol: this.common.searchText,
    };

    this.apiService.getRequest(API_ENDPOINTS.REVERSEBUYERSELLER.GETBUYERREQUIREMENT, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data;

          if (!this.allrecord || this.allrecord.length === 0) {
            this.toastr.error('No data available to export.');
            return;
          }

          const excelData = this.allrecord.map((item, index) => ({
            'Sr.No': item.rowNum,
            'buyerRequirementName': item.buyerRequirementName,
            'budget': item.budget,
            'hsnCode': item.hsnCode,
            'category': item.category,
            'product': item.product,
            'location': item.location,
            'timeLineFromDate': item.timeLineFromDate,
            'timeLineToDate': item.timeLineToDate,
            'termAndConditions': item.termAndConditions,
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          const columnWidths = [
            { wch: 10 }, // Sr.No            
            { wch: 30 }, // OrganizationType Name
            { wch: 40 }, // OrganizationType Description
          ];
          worksheet['!cols'] = columnWidths;

          const workbook: XLSX.WorkBook = {
            Sheets: { 'Buyer Requirement Form List': worksheet },
            SheetNames: ['Buyer Requirement Form List'],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });

          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastr.success('Excel exported successfully!');
        }
      }
    );
  }



  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

  }

